export const ranks = [
  { value: 'Cliente A', text: 'Cliente A' },
  { value: 'Cliente AA', text: 'Cliente AA' },
  { value: 'Cliente AAA', text: 'Cliente AAA' },
  { value: 'Cliente VIP', text: 'Cliente VIP' },
  { value: 'Contado', text: 'Contado' },
  { value: 'Cuentas Claves', text: 'Cuentas Claves' }
]

export const industries = [
  { value: -1, text: '- Sin industria -' },
  { value: 1, text: 'A1 - Construcción' },
  { value: 2, text: 'A2 - Industrial' },
  { value: 3, text: 'A3 - Institución' },
  { value: 4, text: 'A4 - Comercial' },
  { value: 5, text: 'A5 - Condominios' },
  { value: 6, text: 'A6 - Casas' },
  { value: 14, text: 'A7 - Gobierno' },
  { value: 7, text: 'B1 - Inst. Premium' },
  { value: 8, text: 'B2 - Inst. Normal' },
  { value: 9, text: 'B3 - Tienda Especial' },
  { value: 10, text: 'B4 - Retailers' },
  { value: 11, text: 'B5 - Revendedor' },
  { value: 13, text: 'C1 - Administrado' },
  { value: 15, text: 'Público' },
  { value: 16, text: 'Contado' },
  { value: 18, text: 'Regional' }
]

export const subSectors = {
  1: [
    { value: 'A1-1', text: 'Constructoras-Electromecánicas' },
    { value: 'A1-2', text: 'Cemento-Concreto-Vidrio-Materiales' },
    { value: 'A1-3', text: 'Especificación-Diseño-Arquitectura' },
    { value: 'A1-4', text: 'Desarrollador Inmobiliario' },
    { value: 'A1-5', text: 'Constructora de Casas' },
    { value: 'A1-6', text: 'Contratista General' }
  ],
  2: [
    { value: 'A2-1', text: 'Metalmecánica-Plásticos-Carton-Textil'},
    { value: 'A2-2', text: 'Agroindustria'},
    { value: 'A2-3', text: 'Alimentaria y Bebidas' },
    { value: 'A2-4', text: 'Centros Logísticos y Aduanales' },
    { value: 'A2-5', text: 'Alta Tecnología (Médico-Biotec-Electrónica-Electromédico)' },
    { value: 'A2-6', text: 'Comunicación-Energía' },
    { value: 'A2-7', text: 'Química-Petroquímica-Cementos' },
    { value: 'A2-8', text: 'Zona Franca' },
    { value: 'A2-9', text: 'Condominio Industrial-ofibodegas' },
    { value: 'A2-10', text: 'Parque Industrial' },
  ],
  3: [
    { value: 'A3-1', text: 'Bancario-Financiero-Ahorro y Crédito' },
    { value: 'A3-2', text: 'Edificios Gubernamentales' },
    { value: 'A3-3', text: 'Educativo (Univer-Coleg-Esc)' },
    { value: 'A3-4', text: 'Hotelería-Turismo-Clubes-Entretenimiento' },
    { value: 'A3-5', text: 'Cámaras - Colegios Profesionales.' },
    { value: 'A3-6', text: 'Iglesias' },
    { value: 'A3-7', text: 'Otros Edificios Grandes' },
    { value: 'A3-8', text: 'Salud (Clínica-Hospital-Ebais)' }
  ],
  4: [
    { value: 'A4-1', text: 'Automotríz y Transportes' },
    { value: 'A4-2', text: 'Centros y Plazas Comerciales' },
    { value: 'A4-3', text: 'General (Tienda-Farmacia-Oficina-Opticas)' },
    { value: 'A4-4', text: 'Compañías Seguridad(Física-Electrónica)' },
    { value: 'A4-5', text: 'Megatiendas-Supermercados' },
    { value: 'A4-6', text: 'Parqueos públicos' },
    { value: 'A4-7', text: 'CallCenter y Oficinas Corporativas' },
    { value: 'A4-8', text: 'Centro de Deportivo' }
  ],
  5: [
    { value: 'A5-1', text: 'Condominio Horizontal' },
    { value: 'A5-2', text: 'Condominio Vertical' },
    { value: 'A5-3', text: 'Condominio Mixto' },
    { value: 'A5-4', text: 'z - sin asignar' }
  ],
  6: [
    { value: 'A6-1', text: 'Casas de Lujo' },
    { value: 'A6-2', text: 'Constructora de Residencias' },
    { value: 'A6-3', text: 'Fincas' },
    { value: 'A6-4', text: 'Casas' },
    { value: 'A6-5', text: 'Apartamentos' }
  ],
  10: [
    { value: 'B4-1', text: 'Cliente A' },
    { value: 'B4-2', text: 'Cliente B' },
    { value: 'B4-3', text: 'Cliente C' },
    { value: 'B4-4', text: 'Instalador' },
  ],
  14: [
    { value: 'A7-1', text: 'Ministerios'},
    { value: 'A7-2', text: 'Sector Pub Descentralizados'},
    { value: 'A7-3', text: 'Instituciones SemiAutonomas'},
    { value: 'A7-4', text: 'Empresas Publicas Estatales'},
    { value: 'A7-5', text: 'Empresas Publicas no Estatales'},
    { value: 'A7-6', text: 'Municipalidades'},
    { value: 'A7-7', text: 'Concejos Municipales'},
    { value: 'A7-8', text: 'Órganos Adscritos a Instituciones Autónomas'}
  ]
}

export const glnOptions = [
  { value: '01', text: 'Cédula Física' },
  { value: '02', text: 'Cédula Jurídica' },
  { value: '03', text: 'DIMEX' },
  { value: '04', text: 'NITE' },
  { value: '00', text: 'Extranjero' }
]

export const requirementOptions = [
  { value: 'Inducción de contratista', text: 'Inducción de contratista' },
  { value: 'Pólizas de seguros', text: 'Pólizas de seguros' },
  { value: 'Permiso de trabajo seguro', text: 'Permiso de trabajo seguro' },
  { value: 'Paso a paso seguro y/o matriz de riesgos', text: 'Paso a paso seguro y/o matriz de riesgos' },
  { value: 'Equipos de protección personal', text: 'Equipos de protección personal' },
  { value: 'Certificaciones trabajos de alto riesgo (indicadores de vida)', text: 'Certificaciones trabajos de alto riesgo (indicadores de vida)' },
  { value: 'Equipos y herramientas para trabajos de alto riesgo (indicadores de vida)', text: 'Equipos y herramientas para trabajos de alto riesgo (indicadores de vida)' },
  { value: 'Procedimientos de trabajo seguro', text: 'Procedimientos de trabajo seguro' },
  { value: 'Planes y programas', text: 'Planes y programas' },
  { value: 'Supervisión SySOA', text: 'Supervisión SySOA' },
  { value: 'Reuniones SySOA', text: 'Reuniones SySOA' },
  { value: 'Otros documentos', text: 'Otros documentos' }
]
